var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FilterDateChip',{attrs:{"icon":"calendar","is-text":_vm.isText,"label":_vm.$t('search-filters.published-since.name'),"notice":_vm.$t('search-filters.published-since.notice'),"periods":_vm.periods,"value":_vm.value},on:{"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }